const LoadingSpinner = () => {
    return (
        <div className="parent-container">
            <div className="spinner" ></div>
        </div>
    );
};

export default LoadingSpinner;
